import { render, staticRenderFns } from "./dependency-sankey.vue?vue&type=template&id=a0b1511c&"
import script from "./dependency-sankey.vue?vue&type=script&lang=ts&"
export * from "./dependency-sankey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports